export default __webpack_public_path__ + "d304a5f7003777c76cef60d8c5cc14e5.svg";